
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "./icons" // svg
// 引入过滤器
import filters from "./filters";
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import '../node_modules/element-ui/lib/theme-chalk/index.css'
import domMessage from '../messageOnce.js'
// new 对象实例
const messageOnce = new domMessage()
Object.keys(filters).forEach((k) => Vue.filter(k, filters[k]));
import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
import axios from 'axios'
var bus = new Vue()
export default bus
axios.defaults.$axios = axios
Vue.prototype.$axios = axios

axios.defaults.timeout = 50000 // 请求超时
import baseUrl from '../baesUrl'
axios.defaults.withCredentials = true;
axios.defaults.baseURL = baseUrl;
Vue.use(ElementUi)

new Vue({
  router,
  render: function (h) {
    return h(App)
  },
  created() {
    // 请求拦截
    
    // 响应拦截
    axios.interceptors.response.use(
      response => {
        if (response.data.code == "301" || response.data.code == "401") {
          messageOnce.warning({
            message: '登录过期，请重新登录',
            type: 'warning',
            duration:1500
          })
          var timer = setTimeout(()=>{
            this.$router.push({ path: "/login" });
          },1500)
        }
        return response
      },
      error => {
        return Promise.reject(error)
      }
    )
  },
}).$mount('#app')